import LoaderIcon from 'images/icons/loading.svg?react';
import React from 'react';
import DisableWindowScroll from '../DisableWindowScroll/DisableWindowScroll.component';
import { LoaderProps } from './Loader.types';

import {
  LoaderContainer,
  LoaderIconWrapper,
  OverlayContainer,
  OverlayIcon,
} from './style/Loader.style';

const Loader: React.FC<LoaderProps> = ({
  viewMode,
  overlayViewMode,
  active,
  children,
  className,
  animationDelayMs,
  allowDisableWindowScroll = true,
}) => {
  return (
    <LoaderContainer viewMode={viewMode} className={className} active={active}>
      {children}
      {active && (
        <OverlayContainer
          active={active}
          overlayViewMode={overlayViewMode}
          animationDelayMs={animationDelayMs}
        >
          {overlayViewMode === 'fullscreen' && allowDisableWindowScroll && (
            <DisableWindowScroll />
          )}
          <OverlayIcon>
            <LoaderIconWrapper
              iconSize={'60px'}
              svgIconComponent={LoaderIcon}
            />
          </OverlayIcon>
        </OverlayContainer>
      )}
    </LoaderContainer>
  );
};

export default Loader;
